module.exports = __webpack_public_path__ + "static/media/logoDeSic.13d39754.png";